import type { RenderItemProps } from '@/components/StructuredVirtualList'

import { PlaceItem } from './PlaceItem'

type Props = RenderItemProps<'places'>

export function Item(props: Props) {
  return props.type === 'item' ? <PlaceItem {...props} /> : null
}
